
import React from 'react';
import ExecutiveDashboardComponent from '../components/executive_dashboard/ExecutiveDashboard';

const ExecutiveDashboard = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <ExecutiveDashboardComponent />
    </div>
  );
};

export default ExecutiveDashboard;
